import { render, staticRenderFns } from "./CustomerSupportForm.vue?vue&type=template&id=5099961b&"
import script from "./CustomerSupportForm.vue?vue&type=script&lang=js&"
export * from "./CustomerSupportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports